import type { Theme } from '@mui/material';
import type { Look } from '../types/types';
import theme, { createAppTheme } from './theme';
import { boomiDarkLook, boomiLightLook } from './tokens/boomi';

export const THEMES_BY_LOOK: Record<Look, Theme> = {
  elementary: theme,
  'boomi-light': createAppTheme(boomiLightLook),
  'boomi-dark': createAppTheme(boomiDarkLook),
};

// `in` would also accept inherited names such as `toString`.
export const isLook = (look: unknown): look is Look =>
  typeof look === 'string' && Object.keys(THEMES_BY_LOOK).includes(look);
